// src/services/dashboardService.ts
import api from './axios';
import { PaymentRequest } from '../components/subscription-v2/types';

export const getDashboardData = async () => {
  const response = await api.get('/dashboard/metrics');
  if (response.status === 200) {
    return { success: true, data: response.data.data };
  }
  return {success: false, error: response.data};
};

export const getSubscriptionData = async () => {
  const response = await api.get('/subscription/v1/plans');
  if (response.status === 200) {
    return { success: true, data: response?.data?.data?.plans, currentPlan: response?.data?.data?.currentPlan  };
  }
  return {success: false, error: response.data};
};

export const checkEligibility = async (subscriptionDetails: PaymentRequest) => {
  const response = await api.get(`/subscription/v1/preview-invoice?planType=${subscriptionDetails.planType}&paymentFrequency=${subscriptionDetails.paymentFrequency}`);
  if (response.status === 200) {
    return { success: true, data: response.data.data, message: response.data.message };
  }
  return {success: false, error: response.data, message: response.data.message};
};

export const createPaymentSession = async (paymentDetails: any) => {
  const response = await api.post('/subscription/v1/checkout', paymentDetails);
  if (response.status === 200) {
    return { success: true, data: response.data.data };
  }
  return {success: false, error: response.data};
};
export const modifySubscriptionAPI = async (modifyDetails: PaymentRequest) => {
  const response = await api.post('/subscription/v1/change-subscription', modifyDetails);
  if (response.status === 200) {
    return { success: true, data: response.data.data };
  }
  return {success: false, error: response.data};
};

export const cancelSubscriptionAPI = async () => {
  const response = await api.post('/subscription/v1/cancel', {});
  if (response.status === 200) {
    return { success: true, data: response.data.data };
  }
  return {success: false, error: response.data};
};

export const checkSessionStatus = async (sessionId: string) => {
  const response = await api.get(`/subscription/v1/status-check/${sessionId}`);
  if (response.status === 200) {
    return { success: true, status: "success"};
  }else if(response.status === 202) {
    return { success: true, status: "pending"};
  }
  return {success: false, error: response.data};
};

export const getStaticData = async () => {
  const response = await api.get('/dashboard/static-data');
  if (response.status === 200) {
    return { success: true, data: response.data.data };
  }
  return {success: false, error: response.data};
};

export const getSubscriptionBilling = async () => {
    const response = await api.get('/subscription/v1/billing')
    if (response.status === 200) {
      return { success: true, data: response.data};
    }
  return {success: false, error: response.data};
}

export const getTransactionDetails = async () => {
  const response = await api.get('/subscription/v1/transactions')
  if (response.status === 200) {
    return { success: true, data: response.data};
  }
return {success: false, error: response.data};
} 